import { render, staticRenderFns } from "./addVersion.vue?vue&type=template&id=306bf89c&scoped=true"
import script from "./addVersion.vue?vue&type=script&lang=js"
export * from "./addVersion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306bf89c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('306bf89c')) {
      api.createRecord('306bf89c', component.options)
    } else {
      api.reload('306bf89c', component.options)
    }
    module.hot.accept("./addVersion.vue?vue&type=template&id=306bf89c&scoped=true", function () {
      api.rerender('306bf89c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appSet/components/addVersion.vue"
export default component.exports